'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarArrowsRotateReverseDot, iconCalendarArrowsRotateReverseDotTag } from '@ni/nimble-components/dist/esm/icons/calendar-arrows-rotate-reverse-dot';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarArrowsRotateReverseDot };
export { iconCalendarArrowsRotateReverseDotTag };
export const NimbleIconCalendarArrowsRotateReverseDot = wrap(IconCalendarArrowsRotateReverseDot);